import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="refresh"
export default class extends Controller {
  static values = {
    timeout: {
      type: Number,
      default: 5000,
    },
  };

  connect() {
    this.timeoutValue = this.timeoutValue;
    setTimeout(() => {
      location.reload();
    }, this.timeoutValue);
  }
}
